/*!
 * Mobile Genome (Development Release)
 * Copyright 2015 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/media/media',['require','jquery','underscore','backbone','marionette','modernizr','modules/media/channel','modules/media/media-test','core/templates'],function(require) {
  'use strict';

  //////////////
  // IMPORTS //{
  //////////////

  var $ = require('jquery');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Marionette = require('marionette');
  var Modernizr = require('modernizr');
  var Channel = require('modules/media/channel');
  var MediaTest = require('modules/media/media-test');
  var templates = require('core/templates');

  /*****************************************************************************************************************///}

  var Media = Marionette.Module.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    id                : 'media',
    startWithParent   : true,
    available         : false,
    channels          : [],
    primaryChannel    : null,
    bgChannel         : null,
    itemChannel       : null,
    fullWidth         : $(window).width() + 'px',
    fullHeight        : $(window).height() + 'px',
    audioAllowed      : false,//!Modernizr.touch,
    videoAllowed      : false,//!Modernizr.touch,
    checkingMediaType : null,
    basePath          : {
      audio: 'audio/',
      video: 'video/'
    },
    solution          : {
      video: 'none',
      audio: 'none'
    },
    mediaEvents       : { },
    mQueue: null,
    popWin: null,
    poppedOut: false,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    onStart: function(options)
    {
      //console.log('Media::start');

      this.createPrimaryChannel();
      this.createBgChannel();
      this.createItemChannel();

      var radio = Backbone.Wreqr.radio.channel('global');

      radio.vent.on('media.play', $.proxy(this.play, this));
      radio.vent.on('media.stop', $.proxy(this.stop, this));
      radio.vent.on('media:playback:allowed', $.proxy(this.onMediaPlaybackAllowed, this));
      radio.vent.on('ui.button.pressed.caption', $.proxy(this.onCaptionPressed, this));
      radio.vent.on('render.caption', $.proxy(this.renderCaption, this));
      radio.vent.on('render.cc', $.proxy(this.renderCC, this));
      radio.vent.on('clear.cc', $.proxy(this.clearCC, this));

      this.setupCaptions();

      this.mQueue = [];
    },

    onMediaPlaybackAllowed: function(queuedMedia)
    {
      // if (this.checkingMediaType === 'audio')
      //   this.audioAllowed = true;
      // else if (this.checkingMediaType === 'video')
      //   this.videoAllowed = true;
      this.audioAllowed = true;
      this.videoAllowed = true;

      ////console.log(queuedMedia);
      while (this.mQueue.length)
      {
        var $media = this.mQueue.pop();
        $media.options.channel.play($media.file, $media.options);
      }
    },

    onCaptionPressed: function(e)
    {
      ////console.log('Media::onCaptionPressed');

      if (!this.poppedOut)
      {
        if ($('#caption-holder').hasClass('is-open'))
        {
          $('#caption-holder').removeClass('is-open');
          $('#genome .genome-viewport').removeClass('captions-open');
        }
        else
        {
          $('#caption-holder').addClass('is-open');
          $('#genome .genome-viewport').addClass('captions-open');
        }
      }
      else
      {
        if (this.popWin)
        {
          $('body').off('captions.closed');
          this.popWin.onunload = null;
          this.popWin.close();
          this.popWin = null;
        }

        this.poppedOut = false;
        $('#genome .genome-viewport').removeClass('captions-open');
      }
    },

    setupCaptions: function()
    {
      //console.log('setup captions');
      if (Modernizr.touch)
      {
        $('#caption-holder #caption-popout').hide();
      }
      else
      {
        this.poppedOut = false;
        $('#caption-holder #caption-popout').on('click', $.proxy(this.popOutCaptions, this));
      }
    },

    popOutCaptions: function()
    {
      //console.log('popout');
      //$('#caption-holder').hide();
      $('#caption-holder').removeClass('is-open');
      $('body').one('captions.loaded', $.proxy(this.onCaptionsLoaded, this));
      $('body').one('captions.closed', $.proxy(this.popOutClosed, this));//, $('#caption-holder #caption-contents').html()));
      if (!this.popWin || this.popWin.closed)
        this.popWin = window.open('captions.html', 'popWin', 'width=350px, height=450px, left=0, top=0, resizable=1, scrollbars=1');

      this.poppedOut = true;
    },

    onCaptionsLoaded: function()
    {
      this.renderCaption($('#caption-holder #caption-contents').html());
      if (this.popWin)
        this.popWin.focus();
    },

    popOutClosed: function()
    {
      this.poppedOut = false;
      this.popWin.onunload = null;
      this.onCaptionPressed();
      this.popWin = null;
    },

    createPrimaryChannel: function(options)
    {
      options = options || { };

      options.cssSelectorAncestor = '#media-ui';
      options.autonomous = false;

      this.primaryChannel = this.openChannel(options);
    },

    createBgChannel: function(options)
    {
      options = options || { };

      options.autonomous = false;

      this.bgChannel = this.openChannel(options);
    },

    createItemChannel: function(options)
    {
      options = options || { };

      options.autonomous = false;

      this.itemChannel = this.openChannel(options);
    },

    openChannel: function(options)
    {
      options = options || { };

      // set index
      options.index = this.channels.length;

      var channel = new Channel(options);

      this.channels.push(channel);

      return channel;
    },

    closeChannel: function(channel)
    {
      if (channel)
      {
        if (channel.index === 0 && this.popWin)
          this.popWin.close();

        this.channels[channel.index] = null;
        channel.destroy();
      }
      else
      {
        console.error('Error: Specified channel is null or undefined.');
      }
    },

    play: function(file, options)
    {
      options = options || { };
      //console.log('media.play');

      var channel = options.channel || this.primaryChannel;
      options.channel = channel;
      //console.log('play', options);

      var $mediaType = this.getMediaType(file);
      var media = {
        file: file,
        options: options
      };

      if ((this.audioAllowed && $mediaType === 'audio') || (this.videoAllowed && $mediaType === 'video'))
      {
        channel.play(file, options);
      }
      else if (this.checkingMediaType !== $mediaType)
      {
        this.checkingMediaType = $mediaType;
        this.mQueue.push(media);
        var test = new MediaTest({ channel: channel });//media: media, mediaType: $mediaType });
        test.render();

        $('#genome .genome-viewport').append(test.$el);
      }
      else
      {
        this.mQueue.push(media);
      }

      return channel;
    },

    setCaption: function(caption)
    {
      //console.log('Media::setCaption', caption);
      if (!caption)
        return;

      var data = { };

      if (_.isString(caption))
      {
        data.character = 'Narrator';
        data.text = caption;
      }
      else if (_.isPlainObject(caption))
      {
        if (_.isArray(caption) || (caption && caption.text && _.isArray(caption.text)))
        {
          data.character = false;
          _.each(caption.text, function($line) {
            ////console.log('line', $line);
            if (!data.text)
              data.text = '';
            else
              data.text = data.text + '<br />';

            data.text = data.text + '<span class="character">' + $line.character + '</span> ' + $line.caption;
          }, this);
        }
        else
        {
          data.character = caption.character || 'Narrator';
          data.text = caption.text;
        }
      }
      else
      {
        //data = { character: null, text: 'No caption.' };
        data = { character: null, text: '' };
      }
      //console.log('caption data', data);
      var rendered;

      try
      {
        var captionTmpl = templates['modules/media/caption'];
        rendered = captionTmpl(data);
      }
      catch (err)
      {
        console.error('Warning: Invalid JSON format detected.', err);
        rendered = 'No caption.';
      }

      this.renderCaption(rendered);
    },

    renderCaption: function(rendered)
    {
      //console.log('rendercap', rendered);
      $('#caption-holder #caption-contents').empty().html(rendered);
      $('[data-mc=audio_caption_wrapper] [data-mc=audio_caption_text]').empty().html(rendered);
      if (this.popWin && !this.popWin.closed && this.popWin.renderCaption)
        this.popWin.renderCaption(rendered);
    },

    clearCC: function(_ele)
    {
      _ele.find('.jp-video-captions-speaker').empty();
      _ele.find('.jp-video-captions-content').empty();
    },

    renderCC: function(_ele, _char, _text, _cTime)
    {
      if (this.app.Cheats.settings.chatDebug)
        _char.append(' <span> (' + _cTime + ')</span>');
      ////console.log('rendercc', rendered);
      if (true)//this.poppedOut)
      {
        _ele.find('.jp-video-captions-speaker').empty().append(_char);
        _ele.find('.jp-video-captions-content').empty().append(_text);
        return;
      }
    },

    getMediaType: function(filename)
    {
      if (filename.indexOf('.mp3') >= 0)
        return 'audio';
      else if (filename.indexOf('.mp4') >= 0)
        return 'video';
      else
        return 'unknown';
    },

    pause: function(options)
    {
      options = options || { };

      if (options.all)
        _.invoke(this.channels, 'pause');
      else
      {
        this.primaryChannel.pause();
      }
    },

    suspend: function(options)
    {
      options = options || { };

      if (options.all)
        _.invoke(this.channels, 'suspend');
      else
      {
        this.primaryChannel.suspend();
      }
    },

    resume: function(options)
    {
      options = options || { };

      if (options.all)
        _.invoke(this.channels, 'resume');
      else
      {
        this.primaryChannel.resume();
      }
    },

    stop: function(options)
    {
      options = options || { };

      if (options.all)
        _.invoke(this.channels, 'stop');
      else
        this.primaryChannel.stop();
    },

    skip: function(options)
    {
      options = options || { };

      if (options.all)
        _.invoke(this.channels, 'skip');
      else
        this.primaryChannel.skip();
    }

  /*****************************************************************************************************************///}

  });

  return Media;

});

